import { useMemo } from "react";
import { useMessagingData } from "./useMessagingData";

/**
 * Optimized hook that returns total unread message count.
 * Derives data from the master useMessagingData hook (no additional queries).
 */
export function useUnreadMessageCount() {
  const { data: messagingData = [], ...rest } = useMessagingData();
  
  const totalUnread = useMemo(
    () => messagingData.reduce((sum, item) => sum + item.unreadCount, 0),
    [messagingData]
  );

  return {
    data: totalUnread,
    ...rest,
  };
}
